import { render, staticRenderFns } from "./address-manage.vue?vue&type=template&id=3e2aa0e5&scoped=true&"
import script from "./address-manage.vue?vue&type=script&lang=js&"
export * from "./address-manage.vue?vue&type=script&lang=js&"
import style0 from "./address-manage.vue?vue&type=style&index=0&id=3e2aa0e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2aa0e5",
  null
  
)

export default component.exports